let dispatching: Event | null = null;

export const beginDispatch = (event: Event): void => {
  dispatching = event;
  setTimeout(() => {
    if (dispatching === event) {
      dispatching = null;
    }
  }, 0);
};

export const currentDispatch = (): Event | null => dispatching;
